<template>
  <div>
    <b-form-group label="Quantidade">
      <b-form-input v-model="quantidade" type="number" min="1" />
    </b-form-group>

    <div class="div-buttons">
      <b-button variant="primary" @click="cancelar"> Cancelar </b-button>
      <b-button variant="primary" @click="editar"> Salvar </b-button>
    </div>
  </div>
</template>

<script>
import alertMixin from '@/src/mixins/alertMixin'
import servicesMateriaisDisponiveis from '@/src/services/servicesMateriaisDisponiveis'

export default {
  mixins: [alertMixin],
  props: {
    setLoading: {
      type: Function,
      default: () => {},
    },
    close: {
      type: Function,
      default: () => {},
    },
    reload: {
      type: Function,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      quantidade: 0,
    }
  },

  created() {
    this.quantidade = this.item.quantidade
  },

  methods: {
    async editar() {
      if (this.quantidade <= 0) {
        this.errorMessage(
          'Quantidade deve ser maior que 0 (zero). Se você deseja excluir o material disponível, selecione a opção excluir na lista de materiais disponíveis.'
        )
        return
      }
      try {
        this.setLoading(true)
        await servicesMateriaisDisponiveis.edita(this.item._id, this.quantidade)
        this.reload()
        this.close()
        this.setLoading(false)
        this.successMessage('Quantidade editada com sucesso!')
      } catch (error) {
        this.setLoading(false)
        this.errorMessage(
          `Erro ao editar a quantidade do material disponível: ${error.response.data.error.message}`
        )
      }
    },
    cancelar() {
      this.close()
    },
  },
}
</script>

<style>
.div-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
}
</style>